import React, {useState, useEffect} from 'react';
import t from '../../../helpers/t';
import Loader from '../../../components/Loader';
import SidebarFilter from '../../../components/SidebarFilter';
import TagList from '../../../components/TagList';
import {
    useSelector,
    locationActions,
    contingentsActions,
    networksActions,
    tagsActions,
    webFEActions
} from "inbooma-api";
import { Biscuit, getAllUrlParams } from "../../../../utils";
import {$, moment} from '../../../../../vendor';
import SidebarMenu from "./SidebarMenu";
import {getEnvPrefix} from "../../../../utils/Uri";
import {getApiHost, getEnv} from "../../../../Sync";
import * as FileSaver from "../../../../../vendor/FileSaver";
import LargeButton from '../../../components/LargeButton';
import {rbac} from '../index';
import {getFilterData} from "../../../../utils/Helper";
/*import {in_array,getFilterData} from "../../../../utils/Helper";
import Paginator from '../../../components/paginator';*/

const ReservationsSidebar = (props) => {
    const currentUrl = new URL(window.location.href)
    const searchParams = currentUrl.searchParams;
    const allUrlParams = getAllUrlParams(window.location.href)
    allUrlParams?.begin_location_name !== undefined && delete allUrlParams.begin_location_name;
    allUrlParams?.end_location_name !== undefined && delete allUrlParams.end_location_name;
    allUrlParams?.contingent_name !== undefined && delete allUrlParams.contingent_name;
    allUrlParams?.date_from !== undefined && delete allUrlParams.date_from;
    allUrlParams?.date_to !== undefined && delete allUrlParams.date_to;
    allUrlParams?.main_filter !== undefined && delete allUrlParams.main_filter;
    allUrlParams?.direction !== undefined && delete allUrlParams.direction;
    allUrlParams?.sort !== undefined && delete allUrlParams.sort;
    allUrlParams?.type !== undefined && delete allUrlParams.type;
    allUrlParams?.paystate !== undefined && delete allUrlParams.paystate;
    allUrlParams?.types !== undefined && delete allUrlParams.types;
    allUrlParams?.initial !== undefined && delete allUrlParams.initial;
    allUrlParams?.rentalTimeExceeded !== undefined && delete allUrlParams.rentalTimeExceeded;
    const [localSummary, setLocalSummary] = useState(null); //props.summary
    let language = Biscuit.get('user.lang').replace('-','_');

    const [ready,setReady] = useState(false);
    const [globalFilter,setGlobalFilter] = useState(props.filter);                  // default values?

    const [locations,setLocations] = useState([]);
    const [contingents,setContingents] = useState([]);


    const [locationsPending,setLocationsPending] = useState(false);
    const _locations = useSelector(state => state.locations_data.locations);
    const _contingents = useSelector(state => state.contingents_data.contingents);
    const _webFE = useSelector(state => state.web_fe_data.webFE_items);
    const [contingentsPending,setContingentsPending] = useState(false);
    const cleanState = {mainFilter:false,bookingTypeFilter:false,locationBeginFilter:false,locationEndFilter:false,contingentFilter:false,dateFromFilter:false,dateToFilter:false,tagFilter:false,networkFilter:false,paystateFilter:false,typesFilter:false,userFilter:false};
    const [selectedDateFrom,setSelectedDateFrom] = useState(searchParams.get("date_from") !== null ? moment(searchParams.get("date_from"), 'YYYY-MM-DD').toDate() : null);
    const [selectedDateTo,setSelectedDateTo] = useState(searchParams.get("date_to") !== null ? moment(searchParams.get("date_to"), 'YYYY-MM-DD').toDate() : null);
    // const [selectedMainFilter,setSelectedMainFilter] = useState((typeof props.filter.begin_gte !== 'undefined'?'upcoming':null));
    const [selectedMainFilter,setSelectedMainFilter] = useState(searchParams.get("main_filter") !== null ? searchParams.get("main_filter") : !searchParams.get('initial') ? "all" : "upcoming");
    const [statusFilter, setStatusFilter] = useState({value: searchParams.get("status") !== null ? searchParams.get("status") : null});
    const [usedFilterCount,setUsedFilterCount] = useState({mainFilter:(searchParams.get("main_filter") !== null || props.filter.begin_gte !== undefined) ? true : false,bookingTypeFilter:false,locationBeginFilter:searchParams.get("begin_location") !== null ? true : false,locationEndFilter:searchParams.get("end_location") !== null ? true : false,contingentFilter:searchParams.get("contingent_id") !== null ? true : false,dateFromFilter:searchParams.get("date_from") !== null ? true : false,dateToFilter:searchParams.get("date_to") !== null ? true : false ,tagFilter:false,networkFilter:false, paystateFilter:searchParams.get("paystate") !== null ? true : false, typesFilter:searchParams.get("types") !== null ? true : false, userFilter:searchParams.get("user_id") !== null? true: false});
    const [filterCount,setFilterCount] = useState(Object.keys(allUrlParams).length > 0 ? Object.keys(allUrlParams).length : 1);
    // eslint-disable-next-line no-unused-vars
    const [selectedUser,setSelectedUser] = useState((searchParams.get("fullname") !== null && searchParams.get("user_id") !== null) ? {value: searchParams.get("user_id"), label: searchParams.get("fullname")} : null);
    const [selectedBeginLocation,setSelectedBeginLocation] = useState((searchParams.get("begin_location_name") !== null && searchParams.get("begin_location") !== null) ? {id: searchParams.get("begin_location"), name: searchParams.get("begin_location_name")} : null);
    const [selectedEndLocation,setSelectedEndLocation] = useState((searchParams.get("end_location_name") !== null && searchParams.get("end_location") !== null) ? {id: searchParams.get("end_location"), name: searchParams.get("end_location_name")} : null);
    const [selectedContingent,setSelectedContingent] = useState((searchParams.get("contingent_name") !== null && searchParams.get("contingent_id") !== null) ? {id: searchParams.get("contingent_id"), name: searchParams.get("contingent_name")} : null);
    const [selectedPaystate,setSelectedPaystate] = useState((searchParams.get("paystate") !== null && searchParams.get("paystate") !== null) ? {id: searchParams.get("paystate"), name: searchParams.get("paystate_name")} : null);
    const [selectedTypes,setSelectedTypes] = useState((searchParams.get("types") !== null && searchParams.get("types") !== null) ? {id: searchParams.get("types"), name: searchParams.get("types_name")} : null);
    const [selectedItems, setSelectedItems] = useState((searchParams.get("fullname") !== null && searchParams.get("user_id") !== null) ? [{id: searchParams.get("user_id"), name: searchParams.get("fullname")}] : [{}]);

    const _networks = useSelector(state => state["networks_data"].getNetworks);
    const [networks,setNetworks] = useState([]);
    const [networksPending,setNetworksPending] = useState(false);
    const _tags = useSelector(state => state.tags_data.getTagCloud);
    const [tags,setTags] = useState([]);
    const [tagsPending,setTagsPending] = useState(false);
    const [selectedNetwork,setSelectedNetwork] = useState("");
    const [tagSet,setTagSet] = useState(searchParams.get("order_tags") !== null ? true : false);
    const [_resetFilter,_setResetFilter] = useState(props.resetFilter);
    const addReservationUrl = `reservationsList/add${currentUrl.search}`
    // default: nothing selected

    /**
     * can be generally defined in common sidebar
     */
    const onToggleLeftBar = () => {

        $('#inb-c-sidebar').toggleClass('open');
        $('html,body').scrollTop(0);
    };

    useEffect( () => {
        if(_webFE !== {} && typeof _webFE.data !== 'undefined' && _webFE.data.length > 0){
            _webFE.data.map(item => {
               // console.log("item: ",item);
              // console.log(item.app + " === " + Biscuit.get('user.id') + " && " + item.model + " === " + 'ReservationsSummary' + " && "  + item.client_id  + " === " + Biscuit.get('user.client_id') + " && " + item.environment +" === " + getEnv())
                if(item.app === Biscuit.get('user.id')
                    && item.model === 'ReservationsSummary'
                    && item.client_id === Number(Biscuit.get('user.client_id'))
                    && item.environment === getEnv()){

               //     console.log('inside');
                //    console.log(item.data);
                    setLocalSummary(item.data);
                    props.setSummaryPendíng(false);
                    props.dispatch(webFEActions.removeWebFEItemById({id:item._id}));
                }
            });
            return;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[_webFE]);

    /*useEffect(() => {
        if(props.summary !== [] && !props.summaryPending){
            setLocalSummary(props.summary);
        }
    },[props.summary])*/

    const addOrderHandler = () => {}
    // method can be used to proof if filter combination is valid
    const onLocation1SelectHandle = (locationId, locationName, fetch = true) => {
        const location = {name: locationName, id: locationId};
        console.log("begin location selected: ",location);

        // should validate filter combination and start request

        let clone = {...globalFilter};
        let clone2 = {...usedFilterCount};
        if (typeof locationId === 'undefined' || locationId === null){
            delete clone.begin_location;
            clone2.locationBeginFilter = false;
            setSelectedBeginLocation(null);
            searchParams.delete('begin_location');
            searchParams.delete('begin_location_name');
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        } else{
            clone.begin_location = locationId;
            clone2.locationBeginFilter = true;
            setSelectedBeginLocation(location);
            searchParams.set('begin_location', location.id);
            searchParams.set('begin_location_name', location.name);
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        }
        setUsedFilterCount(clone2);
        setGlobalFilter(clone);
        onFilterCountChangeHandle(clone2);
        // fetch wallet transactions
        if(fetch) {
            props.filterChangedHandle(clone);
        }
    };
    const onPaystateSelectHandle = (paystateId, paystateName, fetch = true) => {
        const paystate = {name: paystateName, id: paystateId};
        console.log("paystate selected: ",paystate);

        // should validate filter combination and start request

        let clone = {...globalFilter};
        let clone2 = {...usedFilterCount};
        if (typeof paystateId === 'undefined' || paystateId === null){
            delete clone.paystate;
            clone2.paystateFilter = false;
            setSelectedPaystate(null);
            searchParams.delete('paystate');
            searchParams.delete('paystate_name');
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        } else{
            clone.paystate = paystateId;
            clone2.paystateFilter = true;
            setSelectedPaystate(paystate);
            searchParams.set('paystate', paystate.id);
            searchParams.set('paystate_name', paystate.name);
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        }
        setUsedFilterCount(clone2);
        setGlobalFilter(clone);
        onFilterCountChangeHandle(clone2);
        // fetch wallet transactions
        if(fetch) {
            props.filterChangedHandle(clone);
        }
    };

    const onTypesSelectHandle = (typesId, typesName, fetch = true) => {
        const types = {name: typesName, id: typesId};
        console.log("paystate selected: ",types);

        // should validate filter combination and start request

        let clone = {...globalFilter};
        let clone2 = {...usedFilterCount};
        if (typeof typesId === 'undefined' || typesId === null){
            delete clone.types;
            clone2.typesFilter = false;
            setSelectedTypes(null);
            searchParams.delete('types');
            searchParams.delete('types_name');
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        } else{
            clone.types = typesId;
            clone2.typesFilter = true;
            setSelectedTypes(types);
            searchParams.set('types', types.id);
            searchParams.set('types_name', types.name);
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        }
        setUsedFilterCount(clone2);
        setGlobalFilter(clone);
        onFilterCountChangeHandle(clone2);
        // fetch wallet transactions
        if(fetch) {
            props.filterChangedHandle(clone);
        }
    };

    const onUserSelectHandle = (item, fetch = true) => {
        // should validate filter combination and start request
        var clone = {...globalFilter};
        var clone2 = {...usedFilterCount};
        if (item === null || typeof item.id === 'undefined' || item.id === null){
            delete clone.user_id;
            clone2.userIdFilter = false;
            setSelectedUser(null);
            setSelectedItems([]);
            searchParams.delete('user_id');
            searchParams.delete('fullname');
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        } else{
            const user = {label: item.name, value: item.id};
            clone.user_id = item.id;
            clone2.userIdFilter = true;
            setSelectedUser(user);
            setSelectedItems(user);
            searchParams.set('user_id', user.value);
            searchParams.set('fullname', user.label);
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        }
        setUsedFilterCount(clone2);
        setGlobalFilter(clone);
        onFilterCountChangeHandle(clone2);
        // fetch wallet transactions
        if(fetch) {
            props.filterChangedHandle(clone);
        }
    };

    // method can be used to proof if filter combination is valid
    const onLocation2SelectHandle = (locationId, locationName, fetch = true) => {
        const location = {name: locationName, id: locationId};

        // should validate filter combination and start request

        let clone = {...globalFilter};
        let clone2 = {...usedFilterCount};
        if (typeof locationId === 'undefined' || locationId === null){
            delete clone.end_location;
            clone2.locationEndFilter = false;
            setSelectedEndLocation(null);
            searchParams.delete('end_location');
            searchParams.delete('end_location_name');
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        } else{
            clone.end_location = locationId;
            clone2.locationEndFilter = true;
            setSelectedEndLocation(locationId);
            searchParams.set('end_location', location.id);
            searchParams.set('end_location_name', location.name);
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        }
        setUsedFilterCount(clone2);
        onFilterCountChangeHandle(clone2);
        setGlobalFilter(clone);

        // fetch wallet transactions
        if(fetch) {
            props.filterChangedHandle(clone);
        }
    };

    const onLocationQueryHandle = (query) => {

        // start dispatch of location query
        props.dispatch(locationActions.getLocations({
            token: Biscuit.get('token'),
            filter: {
                findForSelect: true,
                find: 'short',
                limit: 999,
                page: 1,
                q: query
            },
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));
        setLocationsPending(true);
    };

    const onFilterCountChangeHandle = (value) => {
        let clone = {...value};

        let count = 0;
        // eslint-disable-next-line no-unused-vars
        for (const [type,val] of Object.entries(clone)) {
            if(val){
                count++;
            }
        }
        if(count < 1){
            count = 0;
            $('#inb-selected-filters').addClass('hidden');
        } else {
            $('#inb-selected-filters').removeClass('hidden');
        }
        setFilterCount(count);

    };

    const deleteMainTimeFilters = (clone) => {
        if(selectedMainFilter === 'upcoming'){
            delete clone.begin_gte;
        }
        if(selectedMainFilter === 'starts_today'){
            delete clone.begin_day;
        }
        if(selectedMainFilter === 'past'){
            delete clone.end_lt;
        }
        if(selectedMainFilter === 'ends_today'){
            delete clone.end_day;
        }
        if(selectedMainFilter === 'ends_upcoming'){
            delete clone.end_gte;
        }
        if(selectedMainFilter === 'rentalTimeExceeded'){
            delete clone.rentaltimeexceeded;
        }
        return clone;
    };

    const selectedDateToHandle = (date,fetch = true) => {
        searchParams.get("end_lt") !== null && searchParams.delete('end_lt');
        searchParams.get("begin_day") !== null && searchParams.delete('begin_day');
        searchParams.get("end_day") !== null && searchParams.delete('end_day');
        searchParams.get("end_gte") !== null && searchParams.delete('end_gte');
        searchParams.get("main_filter") !== null && searchParams.delete('main_filter');
        searchParams.get("initial") !== null && searchParams.delete('initial');
        let clone = {...globalFilter};
        let clone2 = {...usedFilterCount};
        clone = deleteMainTimeFilters(clone);
        if(date === null){
            if(typeof clone.end_lte !== 'undefined'){
                delete clone.end_lte;
            }
            clone2.dateToFilter = false;
            $('.reservation_to').removeClass('active');
            searchParams.delete('end_lte');
            searchParams.delete('date_to');
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        } else {
            clone.end_lte = moment(date).format('YYYY-MM-DD') + '%2023:59:59';
            $('.reservation_to').addClass('active');
            clone2.dateToFilter = true;
            clone2.mainFilter=false;
            setSelectedMainFilter('all');
            let sort = props.sort;
            sort.direction = (clone2.dateFromFilter?'asc':'desc');
            sort.sort = 'begin';
            props.setSort(sort);
            searchParams.set('end_lte', moment(date).format('YYYY-MM-DD'));
            searchParams.set('date_to', moment(date).format('YYYY-MM-DD'));
            searchParams.set('sort', "begin");
            searchParams.set('direction', clone2.dateFromFilter?'asc':'desc');
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        }
        setGlobalFilter(clone);
        setUsedFilterCount(clone2);
        setSelectedDateTo(date);
        onFilterCountChangeHandle(clone2);
        // reset month and quick filter
        if(fetch) {
            props.filterChangedHandle(clone);
        }
    };

    const selectedDateFromHandle = (date, fetch = true) => {
        searchParams.get("end_lt") !== null && searchParams.delete('end_lt');
        searchParams.get("begin_day") !== null && searchParams.delete('begin_day');
        searchParams.get("end_day") !== null && searchParams.delete('end_day');
        searchParams.get("end_gte") !== null && searchParams.delete('end_gte');
        searchParams.get("main_filter") !== null && searchParams.delete('main_filter');
        searchParams.get("initial") !== null && searchParams.delete('initial');
        let clone = {...globalFilter};
        let clone2 = {...usedFilterCount};
        clone = deleteMainTimeFilters(clone);
        if(selectedMainFilter === 'upcoming'){
            delete clone.begin_gte;
        }
        if(date === null){
            if(typeof clone.begin_gte !== 'undefined'){
                delete clone.begin_gte;
            }
            clone2.dateFromFilter = false;
            if(clone2.dateToFilter){
                let sort = props.sort;
                sort.direction = 'desc';
                sort.sort = 'begin';
                props.setSort(sort);
            }
            $('.reservation_from').removeClass('active');
            searchParams.delete('begin_gte');
            searchParams.delete('date_from');
            searchParams.delete('sort');
            searchParams.delete('direction');
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        } else {
            clone.begin_gte = moment(date).format('YYYY-MM-DD') + '%2000:00:00';
            $('.reservation_from').addClass('active');
            clone2.dateFromFilter = true;
            clone2.mainFilter=false;
            setSelectedMainFilter('all');
            let sort = props.sort;
            sort.direction = 'asc';
            sort.sort = 'begin';
            props.setSort(sort);
            searchParams.set('begin_gte', moment(date).format('YYYY-MM-DD'));
            searchParams.set('date_from', moment(date).format('YYYY-MM-DD'));
            searchParams.set('sort', "begin");
            searchParams.set('direction', "asc");
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        }
        setGlobalFilter(clone);
        setUsedFilterCount(clone2);
        setSelectedDateFrom(date);
        onFilterCountChangeHandle(clone2);
        // reset month and quick filter
        if(fetch) {
            props.filterChangedHandle(clone);
        }
    };

    const dateKeyDownHandle = (e) => {
        console.log("key down date: ",e);
    };

    const onContingentSelectHandle = (contingentId, contingentName, fetch = true) => {
        const contingent = {name: contingentName, id: contingentId}
        // should validate filter combo
        let clone = {...globalFilter};
        let clone2 = {...usedFilterCount};
        if (typeof contingentId === 'undefined' || contingentId === null) {
            delete clone.contingent_id;
            clone2.contingentFilter = false;
            setSelectedContingent(null);
            searchParams.delete('contingent_id');
            searchParams.delete('contingent_name');
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        } else {
            clone.contingent_id = contingentId;
            clone2.contingentFilter = true;
            setSelectedContingent(contingent);
            searchParams.set('contingent_id', contingent.id);
            searchParams.set('contingent_name', contingent.name);
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        }
        setGlobalFilter(clone);
        setUsedFilterCount(clone2);
        onFilterCountChangeHandle(clone2);
        // fetch reservations
        if(fetch) {
            props.filterChangedHandle(clone);
        }
    };

    const onNetworkSelectHandle = (network, fetch = true) => {

        // should validate filter combo
        let clone = {...globalFilter};
        let clone2 = {...usedFilterCount};
        if (typeof network === 'undefined' || network === null) {
            delete clone.network_id;
            clone2.networkFilter = false
            setSelectedNetwork("");
        } else {
            clone.network_id = network;
            clone2.networkFilter = true;
            setSelectedNetwork(network)
        }
        setGlobalFilter(clone);
        setUsedFilterCount(clone2);
        onFilterCountChangeHandle(clone2);
        // fetch reservations
        if(fetch) {
            props.filterChangedHandle(clone);
        }
    };

    const onBookingTypeSelectHandle = (bookingType, fetch = true) => {
        setStatusFilter({value: bookingType});
        // should validate filter combo
        let clone = {...globalFilter};
        let clone2 = {...usedFilterCount};
        if (bookingType === 'cancelled' || bookingType ==='all') {
            if (typeof clone.finder !== 'undefined') {
                delete clone.finder;
                searchParams.delete('finder');
                const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
                history.pushState(null, "", newRelativePathQuery);
            }

        } else {
            if (typeof clone.finder === 'undefined') {
                clone = {...clone,finder: 'NotCancelled'};
                searchParams.set('finder', 'NotCancelled');
                const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
                history.pushState(null, "", newRelativePathQuery);
            }
        }
        if(bookingType === null || bookingType === 'all' || bookingType === 'allwithoutcancelled'){
            delete clone.status;
            if(bookingType === null) {
                clone2.bookingTypeFilter = true;
                searchParams.set('status','allwithoutcancelled');
            } else {
                clone2.bookingTypeFilter = true;
                searchParams.set('status', bookingType);
            }
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);

        } else {
            clone.status = bookingType;
            clone2.bookingTypeFilter = true;
            searchParams.set('status', bookingType);
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        }
        setGlobalFilter(clone);
        setUsedFilterCount(clone2);
        onFilterCountChangeHandle(clone2);
        if(fetch) {
            props.filterChangedHandle(clone);
        }
    };

    const onMainFilterSelectHandle = (item, fetch = true) => {
        allUrlParams?.begin_gte !== undefined && searchParams.delete('begin_gte');
        allUrlParams?.end_lte !== undefined && searchParams.delete('end_lte');
        allUrlParams?.date_from !== undefined && searchParams.delete('date_from');
        allUrlParams?.date_to !== undefined && searchParams.delete('date_to');
        allUrlParams?.rentalTimeExceeded !== undefined && searchParams.delete('rentalTimeExceeded');
        searchParams.delete('initial');
        searchParams.delete('rentalTimeExceeded');
        let newRelativePathQuery = "";
        // should validate filter combo
        // reset all other time or date filter!
        let clone = {...globalFilter};
        clone = deleteAllTimeFilters(clone);
        let clone2 = {...usedFilterCount};
        let sort = props.sort;
        switch (item){
            case "all":
                clone2.mainFilter=false;
                sort = {
                    sort: "order_id",
                    direction: "desc"
                };
                setSelectedMainFilter('all');
                props.setResourceId(null);
                props.setReservationId(null);
                searchParams.delete('begin_gte');
                searchParams.delete('main_filter');
                searchParams.delete('sort');
                searchParams.delete('direction');
                searchParams.get("initial") !== null && searchParams.delete('initial');
                newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
                history.pushState(null, "", newRelativePathQuery);
                break;
            case "upcoming":
                clone2.mainFilter=true;
                clone.begin_gte = moment().format('YYYY-MM-DD') + '%2000:00:00';
                sort = {
                    sort: "begin",
                    direction: "asc"
                };
                setSelectedMainFilter('upcoming');
                searchParams.set('begin_gte', moment().format('YYYY-MM-DD') + '%2000:00:00');
                searchParams.set('main_filter', "upcoming");
                searchParams.set('initial',true);
                searchParams.set('sort', "begin");
                searchParams.set('direction', "asc");
                newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
                history.pushState(null, "", newRelativePathQuery);
                break;
            case "past":
                clone2.mainFilter=true;
                clone.end_lt = moment().format('YYYY-MM-DD HH:mm:ss');
                sort = {
                    sort: "end",
                    direction: "desc"
                };
                setSelectedMainFilter('past');
                searchParams.set('end_lt', moment().format('YYYY-MM-DD H:mm:ss'));
                searchParams.set('main_filter', "past");
                searchParams.get("initial") !== null && searchParams.delete('initial');
                searchParams.set('sort', "end");
                searchParams.set('direction', "desc");
                newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
                history.pushState(null, "", newRelativePathQuery);
                break;
            case "starts_today":
                clone2.mainFilter=true;
                clone.begin_day = moment().format('YYYY-MM-DD');
                sort = {
                    sort: "begin",
                    direction: "asc"
                };
                setSelectedMainFilter('starts_today');
                searchParams.set('begin_day', moment().format('YYYY-MM-DD'));
                searchParams.set('main_filter', "starts_today");
                searchParams.get("initial") !== null && searchParams.delete('initial');
                searchParams.set('sort', "begin");
                searchParams.set('direction', "asc");
                newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
                history.pushState(null, "", newRelativePathQuery);
                break;
            case "ends_today":
                clone2.mainFilter=true;
                clone.end_day = moment().format('YYYY-MM-DD');
                sort = {
                    sort: "end",
                    direction: "desc"
                };
                setSelectedMainFilter('ends_today');
                searchParams.set('end_day', moment().format('YYYY-MM-DD'));
                searchParams.set('main_filter', "ends_today");
                searchParams.get("initial") !== null && searchParams.delete('initial');
                searchParams.set('sort', "end");
                searchParams.set('direction', "desc");
                newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
                history.pushState(null, "", newRelativePathQuery);
                break;
            case "ends_upcoming":
                clone2.mainFilter=true;
                clone.end_gte = moment().format('YYYY-MM-DD HH:mm:ss');
                sort = {
                    sort: "end",
                    direction: "asc"
                };
                setSelectedMainFilter('ends_upcoming');
                searchParams.set('end_gte', moment().format('YYYY-MM-DD HH:mm:ss'));
                searchParams.set('main_filter', "ends_upcoming");
                searchParams.get("initial") !== null && searchParams.delete('initial');
                searchParams.set('sort', "end");
                searchParams.set('direction', "asc");
                newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
                history.pushState(null, "", newRelativePathQuery);
                break;
            case 'rentalTimeExceeded':
                clone2.mainFilter=true;
                clone.rentaltimeexceeded = true;
                sort = {
                    sort: "end",
                    direction: "desc"
                };
                setSelectedMainFilter('rentalTimeExceeded');
                searchParams.set('rentalTimeExceeded',true);
                searchParams.set('main_filter','rentalTimeExceeded');
                searchParams.get("initial") !== null && searchParams.delete('initial');
                searchParams.set('sort', "end");
                searchParams.set('direction', "desc");
                newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
                history.pushState(null, "", newRelativePathQuery);
                break;
            case null:
                clone2.mainFilter=false;
                sort = {
                    sort: "begin",
                    direction: "desc"
                };
                setSelectedMainFilter('all');
                searchParams.delete('begin_gte');
                searchParams.delete('main_filter');
                searchParams.get("initial") !== null && searchParams.delete('initial');
                searchParams.delete('sort');
                searchParams.delete('direction');
                newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
                history.pushState(null, "", newRelativePathQuery);
                break;
        }
        setGlobalFilter(clone);
        setUsedFilterCount(clone2);
        onFilterCountChangeHandle(clone2);
        if(fetch) {
            props.filterChangedHandle(clone,sort);
        }
    };

    const deleteAllTimeFilters = (item) =>
    {
        if(typeof item["begin_lte"] !== 'undefined'){
            delete item["begin_lte"];
        }
        if(typeof item["begin_gte"] !== 'undefined'){
            delete item["begin_gte"];
        }
        if(typeof item["begin_day"] !== 'undefined'){
            delete item["begin_day"];
        }
        if(typeof item["end_day"] !== 'undefined'){
            delete item["end_day"];
        }
        if(typeof item["end_lt"] !== 'undefined'){
            delete item["end_lt"];
        }
        if(typeof item["begin_lt"] !== 'undefined'){
            delete item["begin_lt"];
        }
        if(typeof item["end_gt"] !== 'undefined'){
            delete item["end_gt"];
        }
        if(typeof item["begin_gt"] !== 'undefined'){
            delete item["begin_gt"];
        }
        if(typeof item["end_lte"] !== 'undefined'){
            delete item["end_lte"];
        }
        if(typeof item["end_gte"] !== 'undefined'){
            delete item["end_gte"];
        }
        if(typeof item["begin"] !== 'undefined'){
            delete item["begin"];
        }
        if(typeof item["end"] !== 'undefined'){
            delete item["end"];
        }
        selectedDateFromHandle(null, false);
        selectedDateToHandle(null, false);
        setSelectedDateFrom(null);
        setSelectedDateTo(null);
        let usedFilterC = {...usedFilterCount};
        usedFilterC.dateToFilter = false;
        usedFilterC.dateFromFilter = false;
        setUsedFilterCount(usedFilterC);
        return item;
    };

    const onContingentQueryHandle = (query) => {

        // start dispatch of user query
        props.dispatch(contingentsActions.getContingents({
            token: Biscuit.get('token'),
            filter: {
                find: 'short',
                limit: 999,
                page: 1,
                q: query
            },
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));
        setContingentsPending(true);
    };

    const onNetworkQueryHandle = (query) => {

        // start dispatch of user query
        props.dispatch(networksActions.getNetworks({
            token: Biscuit.get('token'),
            filter: {
                q: query
            },
            suffix: '',
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));
    };

    /*const getUserDisplayName = (user_id) => {

        return user.first_name + ' ' + user.last_name;
    };*/


    useEffect(() => {

        if (_locations.success === "" || !locationsPending) return;

        if (_locations.success === true) {
            setLocations([..._locations.data]);
        } else if (_locations.success === false) {
            console.log("Failed to request users!");
        }
        setLocationsPending(false);
        if (contingentsPending === false && tagsPending === false && networksPending === false) setReady(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[_locations]);

    useEffect(() => {

        if (_contingents.success === ""  || !contingentsPending) return;

        if (_contingents.success === true) {
            // compute name attribute '_name'
            let clone = [..._contingents.data];

            setContingents(clone);
        } else if (_contingents.success === false) {
            console.log("Failed to request contingents!");
        }
        setContingentsPending(false);
        if (locationsPending === false && tagsPending === false && networksPending === false) setReady(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[_contingents]);

    useEffect(() => {

        if (!_resetFilter) return;

        if (_resetFilter) {
            resetFilter();
        }
        _setResetFilter(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[_resetFilter]);

    useEffect(() => {
        if (_networks.success === "" || !networksPending) return;

        if (_networks.success === true) {
            // compute name attribute '_name'
            let clone = [..._networks.data];

            setNetworks(clone);
        } else if (_networks.success === false) {
            console.log("Failed to request networks!");
        }
        setNetworksPending(false);
        if (locationsPending === false && contingentsPending === false && tagsPending === false) setReady(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[_networks]);

    useEffect(() => {
        if (_tags.success === "" || !tagsPending) return;

        if (_tags.success === true) {
            // compute name attribute '_name'
            let clone = [..._tags.data];
            setTags(clone);
        } else if (_tags.success === false) {
            console.log("Failed to request tag-cloud!");
        }
        setTagsPending(false);
        if (locationsPending === false && contingentsPending === false && networksPending === false) setReady(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[_tags]);

    //console.log(allUrlParams,'allUrlParams');
    const initialize = () => {
        if (ready) {
           // updateTagList();
            return;
        }

        if (locationsPending || contingentsPending || networksPending || tagsPending) return;

        // get locations and users to filter for
        props.dispatch(locationActions.getLocations({
            token: Biscuit.get('token'),
            filter: {
                findForSelect: true,
                find: 'short',
                limit: 999,
                page: 1
            },
            parameters: {
                headers: {
                    'Accept-Language': language
                }
            }
        }));
        setLocationsPending(true);

        props.dispatch(contingentsActions.getContingents({
            token: Biscuit.get('token'),
            filter: {
                find: 'short',
                limit: 999,
                page: 1
            },
            parameters: {
                headers: {
                    'Accept-Language': language
                }
            }
        }));
        setContingentsPending(true);
        // get locations and users to filter for
        props.dispatch(networksActions.getNetworks({
            token: Biscuit.get('token'),
            suffix: '',
            parameters: {
                headers: {
                    'Accept-Language': language
                }
            }
        }));
        setNetworksPending(true);

        props.dispatch(tagsActions.getTagCloud({
            token: Biscuit.get('token'),
            filter: {
                namespace: 'Orders'
            },
            suffix: '',
            parameters: {
                headers: {
                    'Accept-Language': language
                }
            }
        }));
        setTagsPending(true);

    };

    if (!ready) initialize();
    const updateTagList = () =>
    {
        let fakeTagBox,tagBox = document.getElementById("inb-c-left-bar-flist--tag");
        for (let i=0;i<tagBox.childNodes.length;i++) {
            if (tagBox.childNodes[i]["tagName"] === "LI") {
                tagBox.removeChild(tagBox.childNodes[i]);
                i--;
            }
            else if (tagBox.childNodes[i]["tagName"] === "UL") {
                fakeTagBox = tagBox.childNodes[i];
                fakeTagBox.innerHTML = "";
            }
        }
        // set hidden tags and fake tags
        for(let u=0;u<tags.length;u++) {
            // hidden tags
            let tag = document.createElement("li");
            let content = document.createElement("a");
            content.innerHTML = tags[u].label;
            content.setAttribute("href","#");
            content.setAttribute("class","order-sidebar-tag-link");
            tag.setAttribute("class","hide");
            tag.setAttribute("data-counter",tags[u].counter);
            tag.setAttribute("data-inb-val",tags[u].label);
            tag.setAttribute("title",t('filter_tag_${a}',{a:tags[u].label}) );
            tag.appendChild(content);
            tagBox.appendChild(tag);

            // fake tags
            if (fakeTagBox === undefined) continue;
            let fakeTag = document.createElement("li");
            let fakeContent = document.createElement("a");
            fakeContent.innerHTML = tags[u].label;
            fakeContent.setAttribute("href","#");
            fakeTag.setAttribute("class","inb-fake-tag");
            fakeTag.setAttribute("data-counter",tags[u].counter);
            fakeTag.setAttribute("data-inb-val",tags[u].label);
            fakeTag.setAttribute("title",t('filter_tag_${a}',{a:tags[u].label}) );
            fakeTag.appendChild(fakeContent);
            fakeTagBox.appendChild(fakeTag);
        }
    }
    const ClickHandler = (value) =>
    {
        if(value==='export-xls'){
            _export();
        }
    }

    const onTagClicked = (tag) =>
    {
        // should validate filter combo
        let clone = {...globalFilter};
        let clone2 = {...usedFilterCount};
        if (typeof tag === 'undefined' || tag === null) {
            delete clone.order_tags;
            clone2.tagFilter = false;
            setTagSet(false);
            searchParams.delete('order_tags');
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        } else {
            clone.order_tags = tag;
            clone2.tagFilter = true;
            setTagSet(true);
            searchParams.set('order_tags', tag);
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        }
        setGlobalFilter(clone);
        setUsedFilterCount(clone2);
        onFilterCountChangeHandle(clone2);
        // fetch reservations
        if(fetch) {
            props.filterChangedHandle(clone);
        }
    }

    const onTagRemoved = () => {
        let clone = {...globalFilter};
        let clone2 = {...usedFilterCount};
        delete clone.order_tags;
        clone2.tagFilter = false;
        setTagSet(false);
        setGlobalFilter(clone);
        setUsedFilterCount(clone2);
        onFilterCountChangeHandle(clone2);
        props.filterChangedHandle(clone);
        searchParams.delete('order_tags');
        const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
        history.pushState(null, "", newRelativePathQuery);
    }

    const getMenu = () =>
    {
        const host = getEnvPrefix();
        let menu = [
            /*{
                text: t('help',null,'capital'),
                href: "/reservationsList/help",
                iconClass: "ico-inb inb-fi-help",
                title: "help-link",
                handler: ClickHandler,
                id: 'help'
            },
           {
               spacer: true
           },*/
           {
                text: t('export_xls', null, 'capital'),
                href: "#",
                iconClass: "ico-inb inb-fi-excel",
                rel: "noopener noreferrer",
                title: "export-xls",
                id: "export-xls",
                handler: ClickHandler
           },
            {
                spacer: true
            }
        ];
       if(Biscuit.get('user.role') !== 'user'){
           menu.push({
               text: t('daily_rental_contract', null, 'capital'),
               href: "/orders/export",
               iconClass: "ico-inb inb-fi-pdf",
               title: "export-pdf",
               id: "export-pdf",
               handler: ClickHandler
           });
       }
       if(Biscuit.get('client.isVehicleOwner') === 'true' ||
           Biscuit.get('client.isBikeSharing') === 'true' || Biscuit.get('client.hasParkingLots') === 'true')
        {
            menu.push({
                spacer: true
            });
            menu.push({
                text: t('schedule', null, 'capital'),
                href: "https://" + host + "cal.inbooma.net?hash="+ Biscuit.get('client.hash'),
                target: "_blank",
                rel: "noopener noreferrer",
                iconClass: "ico-inb inb-fi-calendar",
                title: "schedule",
                id: "schedule",
                handler: ClickHandler
            });
        }
        if(Biscuit.get('user.client_id') === 7){
            menu.push({
                spacer: true
            });
            menu.push(
                {
                    text: t('schedule_heart_route', null, 'capital'),
                    href: "https://" + host + "cal.inbooma.net?hash=" + Biscuit.get('client.hash') + "&network=herzroute",
                    target: "_blank",
                    rel: "noopener noreferrer",
                    iconClass: "ico-inb inb-fi-calendar",
                    title: "schedule_heart_route",
                    id: "schedule_heart_route",
                    handler: ClickHandler
                }
            )
        }
        return menu;
    }

    const _export = () => {
        let params = '', count=0, begin = null, end =null;
        let clone = {...globalFilter};
        for (const [type, val] of Object.entries(clone)) {
            if(count > 0){
                params += '&'+type+'='+val;
            }else{
                params += '?'+type+'='+val;
            }
            count++;
            if(type === 'begin_gte' || type === 'begin_gt'){
                begin = val.substr(0,10);
            }
            if(type === 'begin_lte' || type === 'begin_lt'){
                end = val.substr(0,10);
            }
        }
        let timestamping = "";
        if(begin !== null){
            timestamping = t('von') +' ' + get_date(begin)+" ";
        }
        if(end !== null){
            timestamping += t('bis') + ' ' + get_date(end)+" ";
        }
        const xmlHttp = new XMLHttpRequest();

        xmlHttp.open("GET", getApiHost() + '/reservations/export'+params, true);

        //  xmlHttp.setRequestHeader('Accept', 'application/json')
        xmlHttp.setRequestHeader('Authorization', 'Bearer ' + Biscuit.get('token'));
        xmlHttp.setRequestHeader('Content-Language',language);
        xmlHttp.setRequestHeader('Accept-Language',language);
        xmlHttp.responseType = "blob";

        xmlHttp.onload = function() {


            const blob = new Blob([xmlHttp.response], { type: 'application/xls' });
            FileSaver.saveAs(blob, t("reservations") +" "+timestamping+".xlsx");

        };

        xmlHttp.send(null);


    };

    const get_date = (date = null) => {
        let today = new Date();

        if(date !== null){
            today= new Date(date);
        }
        let day = today.getDate(); // Tag
        // Monatsangabe startet bei 0!
        let month = today.getMonth()+1; // Monat

        let year = today.getFullYear(); // Jahr
        if(day < 10) {
            day = '0'+ day;
        }
        if(month < 10) {
            month = '0'+ month;
        }

        today = day + '.' + month + '.' + year;
        return today;
       /* if(date === null){
            return moment().format('DD.MM.YYYY');
        }
        console.log(date);
        return moment(new Date(date)).format('DD.MM.YYYY');*/
    };

    const resetFilter = () =>
    {
        selectedDateFromHandle(null, false);
        selectedDateToHandle(null, false);
        setSelectedBeginLocation(null);
        setSelectedEndLocation(null);
        setSelectedContingent(null);
        setStatusFilter({value:'allwithoutcancelled'});
        setSelectedTypes(null);
        setSelectedPaystate(null);
        setTagSet(false);
       /* onBookingTypeSelectHandle(null, false);
        onContingentSelectHandle(null, false);
        onLocation1SelectHandle(null,false);
        onLocation2SelectHandle(null,false);
        onMainFilterSelectHandle(null, false);

        $('#inb-c-left-bar-flist--reservations-begin-location .inbooma-select-box__input').prop("");
        $('#inb-c-left-bar-flist--reservations-end-location .inbooma-select-box__input').prop("");
        $('.inbooma-select-box__reset').trigger('click');*/
        let clone = {
            find: 'full',
            finder: 'NotCancelled'
        };
        setSelectedMainFilter('all');
        setUsedFilterCount(cleanState);
        setFilterCount(0);
        setGlobalFilter(clone);
        onFilterCountChangeHandle(cleanState);

        const newRelativePathQuery = window.location.pathname + "?type=bookings";
        history.pushState(null, "", newRelativePathQuery);
        props.filterChangedHandle(clone, {
            sort: "order_id",
            direction: "desc"
        });
        setReady(false);
        initialize();
        props.setResetFilter(clone);
    }

        return (
            <aside
                id="inb-c-sidebar"
                style={{float: 'left'}}>
                <header className="inb-c-left-bar__title sticky-top">
                    <h1 className="inb-page-title">
                        {props.heading}
                    </h1>
                    <SidebarMenu
                        menu={
                            getMenu()
                        }
                    />
                </header>

                {!ready &&
                <Loader
                    mediumWidth={4}
                    smallWidth={4}
                    subLoaders={2}/>
                }
                {ready &&
                <>
                <div className="sticky-top-filter">
                    <aside id="inb-selected-filters">
                        {filterCount > 0 && <ul>
                            <p>
                                <i className="fi fi-filter"> </i>
                                <span id="inb-selected-filters__count">
                               {" " + filterCount}
                             </span>

                                {" " + t('filter_selected')}
                                <a href="#"
                                   id="inb-selected-filters__unset"
                                   className="unset-filter"
                                   title={t('unselect_all_filter')} onClick={(e) => {
                                    resetFilter(e)
                                }}>
                                    x
                                </a>
                            </p>
                        </ul>}
                    </aside>
                    {<SidebarFilter
                        id="inb-c-left-bar-flist--reservations-main"
                        heading=""
                        type="list"
                        data={
                            getFilterData(  [
                                {name: t('all'), summaryItem: "allCount", value: 'all'},
                                {name: t('upcoming'), summaryItem: "upcomingCount", value: 'upcoming'},
                                {name: t('past'), summaryItem: "passedCount" , value: 'past'},
                                {name: t('starts_today'), summaryItem: "beginTodayCount", value: 'starts_today'},
                                {name: t('ends_today'), summaryItem: "endTodayCount" , value: 'ends_today'},
                                {name: t('ends_upcoming'), summaryItem: "upcomingEndCount", value: 'ends_upcoming'},
                                {name: t('Return time exceeded'), summaryItem: "rentalTimeExceededCount", value: 'rentalTimeExceeded'}
                            ], props.summaryPending, localSummary)
                        }
                        dataKey="value"
                        selected={selectedMainFilter}
                        summaryPending={props.summaryPending}
                        onChangeHandle={onMainFilterSelectHandle}/>}
                    {/*<SidebarFilter
                        id="inb-c-left-bar-flist--reservations-main"
                        heading=""
                        type="list"
                        data={
                            [
                                {name: t('all'), value: 'all'},
                                {name: t('upcoming'), value: 'upcoming'},
                                {name: t('past'), value: 'past'},
                                {name: t('starts_today'), value: 'starts_today'},
                                {name: t('ends_today'), value: 'ends_today'},
                                {name: t('ends_upcoming'), value: 'ends_upcoming'}
                            ]
                        }
                        dataKey="value"
                        selected={selectedMainFilter !== null ? selectedMainFilter : undefined}
                        onChangeHandle={onMainFilterSelectHandle}/>*/}
                    <SidebarFilter
                        id="inb-c-left-bar-flist--reservations-date"
                        heading={t('bookingtime', null, 'capital')}
                        type="datePicker"
                        data={[{
                            name: "date_from",
                            className: "noBorders-noBackground",
                            dateFormat: "dd.MM.y",
                            selected: selectedDateFrom,
                            onChangeHandle: selectedDateFromHandle,
                            onKeyDownHandle: dateKeyDownHandle,
                            placeholder: t('valid_from', null, 'capital') + ' ...',
                            extraClassName: "reservation_from"
                        }, {
                            name: "date_to",
                            className: "noBorders-noBackground",
                            dateFormat: "dd.MM.y",
                            selected: selectedDateTo,
                            onChangeHandle: selectedDateToHandle,
                            onKeyDownHandle: dateKeyDownHandle,
                            placeholder: ' ...' + t('valid_to', null, 'capital'),
                            extraClassName: "reservation_to"
                        }]}/>
                    {<SidebarFilter
                        id="inb-c-left-bar-flist--reservations-status"
                        heading={t('reservation_status')}
                        type="list"
                        data={
                          getFilterData(  [
                              {name: t('all'), summaryItem: "allStatusCount", value: 'all'},
                              {name: t('all (without cancelled)'), summaryItem: "allWithoutCancelledCount", value: 'allwithoutcancelled'},
                              {name: t('requested',null,'capital'), summaryItem: "requestedCount", value: 'requested'},
                              {name: t('confirmed'), summaryItem: "confirmedCount", value: 'confirmed'},
                              {name: t('inprogress'), summaryItem: "inprogressCount", value: 'inprogress'},
                              {name: t('completed'), summaryItem: "completedCount", value: 'completed'},
                              {name: t('cancelled'), summaryItem: "cancelledCount", value: 'cancelled'}
                          ],props.summaryPending,localSummary)
                        }
                        dataKey="value"
                        selected={typeof statusFilter?.value !== 'undefined' && statusFilter?.value !== null ? statusFilter.value : 'all'}
                        summaryPending={props.summaryPending}
                        onChangeHandle={onBookingTypeSelectHandle}/>}
                   {/* <SidebarFilter
                        id="inb-c-left-bar-flist--reservations-status"
                        heading={t('reservation_status')}
                        type="list"
                        data={[{
                            name: t('all', null, 'capital'), value: 'all'
                        }, {
                            name: t('requested', null, 'capital'), value: 'requested'
                        }, {
                            name: t('confirmed', null, 'capital'), value: 'confirmed'
                        }, {
                            name: t('inprogress', null, 'capital'), value: 'inprogress'
                        }, {
                            name: t('completed', null, 'capital'), value: 'completed'
                        }, {
                            name: t('cancelled', null, 'capital'), value: 'cancelled'
                        }
                        ]}
                        dataKey="value"
                        selected={typeof statusFilter?.value !== 'undefined' && statusFilter?.value !== null ? statusFilter.value : undefined}
                        onChangeHandle={onBookingTypeSelectHandle}/>*/}
                    {ready && rbac.hasPermission('edit') &&
                    <>
                        {Biscuit.get('client.show_usage_types') === 'true' &&

                            <SidebarFilter
                                id="inb-c-left-bar-flist--reservations-paystate"
                                heading={t('types')}
                                type="select2"
                                data={[
                                    {
                                        "id" : 'booking',
                                        "name": t('usage_type_booking')
                                    },
                                    {
                                        "id": 'service',
                                        "name": t("usage_type_service")
                                    },
                                    {
                                        "id": 'official',
                                        "name": t("usage_type_official")
                                    }
                                ]}
                                dataKey="id"
                                nameAttribute="name"
                                onChangeHandle={onTypesSelectHandle}
                                value={selectedTypes !== null?selectedTypes:null}
                                placeholder={'- ' + t('all', null, 'capital') + ' -'}
                                //selected={selectedBeginLocation}
                            />
                        }
                        <SidebarFilter
                            id="inb-c-left-bar-flist--reservations-paystate"
                            heading={t('paystate')}
                            type="select2"
                            data={[
                                {
                                    "id" : 'unpaid',
                                    "name": t('unpaid')
                                },
                                {
                                    "id": 'paid',
                                    "name": t("paid")
                                },
                                {
                                    "id": 'refund',
                                    "name": t("refunded")
                                }
                            ]}
                            dataKey="id"
                            nameAttribute="name"
                            onChangeHandle={onPaystateSelectHandle}
                            value={selectedPaystate !== null?selectedPaystate:null}
                            placeholder={'- ' + t('all', null, 'capital') + ' -'}
                            //selected={selectedBeginLocation}
                        />
                        <SidebarFilter
                            id="inb-c-left-bar-flist--reservations-begin-location"
                            heading={t('location_of_checkin')}
                            type="select2"
                            data={locations}
                            dataKey="id"
                            nameAttribute="name"
                            onQueryHandle={onLocationQueryHandle}
                            onChangeHandle={onLocation1SelectHandle}
                            value={selectedBeginLocation !== null?selectedBeginLocation:null}
                            placeholder={'- ' + t('all', null, 'capital') + ' -'}
                            //selected={selectedBeginLocation}
                        />
                        <SidebarFilter
                            id="inb-c-left-bar-flist--reservations-end-location"
                            heading={t('location_of_checkout')}
                            type="select2"
                            data={locations}
                            dataKey="id"
                            nameAttribute="name"
                            onQueryHandle={onLocationQueryHandle}
                            onChangeHandle={onLocation2SelectHandle}
                            value={selectedEndLocation !== null?selectedEndLocation:null}
                            // selected={selectedEndLocation}
                            placeholder={'- ' + t('all', null, 'capital') + ' -'}
                        />
                    <SidebarFilter
                        id="inb-c-left-bar-flist--reservations-contingent"
                        heading={t('contingent')}
                        type="select2"
                        data={contingents}
                        dataKey="id"
                        nameAttribute="name"
                        onQueryHandle={onContingentQueryHandle}
                        onChangeHandle={onContingentSelectHandle}
                        value={selectedContingent}
                        placeholder={'- ' + t('all', null, 'capital') + ' -'}/>
                        <SidebarFilter
                            id="inb-c-left-bar-flist--orders-users"
                            heading={t('user')}
                            type="InboomaSelect"
                            sortBy='created'
                            sortDirection='desc'
                            placeholder={'- ' + t('all', null, 'capital') + ' -'}
                            selectedItems={selectedItems}
                            setSelectedItems={setSelectedItems}
                            onSelectHandle={onUserSelectHandle}
                            dispatch={props.dispatch}
                            multiSelect={false}
                            advanced={true}
                            extraStyle={{width:"700px"}}
                        />
                    </>}
                    {ready && rbac.hasPermission('edit') &&  <>{networks.length > 0 &&
                        <>
                            <SidebarFilter
                                id="inb-c-left-bar-flist--reservations-network"
                                heading={t('network')}
                                type="select2"
                                data={networks}
                                dataKey="id"
                                onQueryHandle={onNetworkQueryHandle}
                                onChangeHandle={onNetworkSelectHandle}
                                value={selectedNetwork}
                                placeholder={'- ' + t('all', null, 'capital') + ' -'}
                            />
                        </>
                    }</>}
                    {ready && rbac.hasPermission('edit') && <>
                        <TagList
                            onTagClicked={onTagClicked}
                            updateTagList={updateTagList}
                            tags={tags}
                            onFilterRemoveHandle={onTagRemoved}
                            tagSetted={tagSet}
                        />

                        </>}

                </div>
                </>
                }
                {rbac.hasPermission('edit') && <><footer className="inb-c-left-bar__footer small-only-float-container center-on-content">
                    <a href="#"
                       id="toggle-left-bar"
                       className="button secondary show-for-small-only" onClick={(e) => onToggleLeftBar(e)}>
                        <i className="fi fi-filter"> </i>
                        <span className="show-for-sr">{t('open_filter_menu')}</span>
                    </a>
                    <LargeButton
                        link={addReservationUrl}
                        beautify={true}
                        icon="fi fi-page-add"
                        title={t('add_${a}',{a:t('order')})}
                        name="add-orders"
                        handler={addOrderHandler}/>

                </footer>
                </>
                }
            </aside>
        );

};

export default ReservationsSidebar;

